import { combineReducers } from 'redux';
import * as cart from './cart';

export * from './cart';

export type OrdersState = {
  cart: cart.CartState;
};

export const initialOrdersState: OrdersState = {
  cart: cart.initialCartState,
};

export const ordersReducers = combineReducers({
  cart: cart.cartReducer,
});
